export const queryKeys = {
  user: {
    me: ['user', 'me'] as const,
    exists: (email: string) => ['user', 'exists', email] as const,
  },
  invite: {
    validate: (token: string) => ['invite', 'validate', token] as const,
  },
  relationship: {
    root: ['relationship'] as const,
    byId: (id: string) => ['relationship', id] as const,
  },
  wishlist: {
    me: (relationshipId: string) => ['wishlist', 'me', relationshipId] as const,
    partner: (relationshipId: string) =>
      ['wishlist', 'partner', relationshipId] as const,
  },
  occasions: {
    me: (relationshipId: string) =>
      ['occasions', 'me', relationshipId] as const,
  },
} as const;
